export default __webpack_public_path__ + "static/media/recruit_section_image_3.25c009c0.webp";